module.exports = __webpack_public_path__ + "static/img/3.6116b820.jpg";